import { makeStyles } from '@mui/styles';

const style = makeStyles((theme: any) => ({
  root: {
    borderBottom: `1px solid rgba(164, 163, 255, 0.3)`
  }
}));

export default style;
